export default __webpack_public_path__ + "static/media/CAL32250.bbc5b5b9.jpg";